import { AlertBarNotifierBase } from "./alertbar-notifier-base";

export class AlertBarMainNotifier extends AlertBarNotifierBase {

}